// import { canUseDOM } from 'exenv';

export function wpPageLoading(resp = {}, store = {}) {
  return {
    type: 'WP_PAGE_LOADING',
    wpPage: resp,
    store
  };
}

export function wpPageLoaded(resp = {}, store = {}) {
  return {
    type: 'WP_PAGE_LOADED',
    wpPage: resp,
    store
  };
}

export function wpPageLoadError(error, store = {}) {
  return {
    type: 'WP_PAGE_ERROR',
    wpPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
